import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { BankAccountFormSchemaValues } from 'src/features/billingEntityBankAccounts/utils/formSchema';
import { BankAccount } from 'src/features/billingEntityBankAccounts/utils/types';

const RESOURCE = '/customers/billing-entity-bank-account/:bankAccountId/';

type MutationFnType = typeof mutationFn;

interface DTO extends BankAccountFormSchemaValues {
    bankAccountId: string;
}
const mutationFn = ({ bankAccountId, ...data }: DTO): Promise<BankAccount> => {
    return axios.put(formatResourcePath(RESOURCE, { bankAccountId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateBillingEntityBankAccount };
